import { z } from "zod";

//Esquema de validação regras e mensagens de erro
export const schema = z
	.object({
		param: z.string(),
		paramValue: z.string(),
		active: z.boolean(),
	})
	.transform((fields) => ({
		...fields,
		paramValue: fields.paramValue.toLocaleUpperCase(),
	}));
